<template>
    <v-dialog :value="value" persistent max-width="400px">
        <v-card>
            <v-card-title class="green white--text">
                <v-spacer />
               НАСТРОЙКА
                <v-spacer />
                <v-btn dark icon @click="$emit('input')" title="Закрыть"><v-icon>fas
                        fa-times</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="py-4">
                    <v-radio-group v-model="showAll" label="Фильтрация контактов">
                        <v-radio label="Все" value="1"></v-radio>
                        <v-radio label="Непрочитанные" value="2"></v-radio>
                        <v-radio label="Только отвеченные" value="3"></v-radio>
                        <v-radio label="Только прочитанные" value="4"></v-radio>
                    </v-radio-group>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn class="primary" @click="done()">Применить</v-btn>
                <v-btn @click="$emit('input')" title="Закрыть">Закрыть</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        filters: Object,
    },
    data() {
        return {

        }
    },
    computed: {
        showAll: {
            get() {
                if (this.filters["wa.viewed"] === 0) return "2";
                else if (this.filters["wa.direction"] === 0) return "3";
                else if (this.filters["wa.status"] === 0) return "4";
                else return "1";
            },
            set(v) {
                if (v == 2) {
                    this.$emit("filters", Object.assign({}, this.filters, {
                        "wa.viewed": 0,
                        "wa.direction": undefined,
                        "wa.status": undefined
                    }));
                } else if (v == 3) {
                    this.$emit("filters", Object.assign({}, this.filters, {
                        "wa.viewed": undefined,
                        "wa.direction": 1,
                        "wa.status": undefined
                    }))
                } else if (v == 4) {
                    this.$emit("filters", Object.assign({}, this.filters, {
                        "wa.viewed": undefined,
                        "wa.direction": undefined,
                        "wa.status": 4
                    }))
                } else {
                    this.$emit("filters", Object.assign({}, this.filters, {
                        "wa.viewed": undefined,
                        "wa.direction": undefined,
                        "wa.status": undefined
                    }));
                }
            }
        }
    },
    methods: {
        done() {
            this.$emit('input');
        }
    }
}
</script>